<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    class="flex justify-between dark:text-gray-300 text-grayLightMode-300 w-full"
  >
    <div class="flex space-x-2">
      <!-- logo -->
      <svg
        class="h-8 my-auto dark:text-gray-900 text-grayLightMode-100"
        viewBox="0 0 67 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33.5011 67.0239C52.0032 67.0239 67.0021 52.0201 67.0021 33.5119C67.0021 15.0038 52.0032 0 33.5011 0C14.9989 0 0 15.0038 0 33.5119C0 52.0201 14.9989 67.0239 33.5011 67.0239Z"
          fill="url(#paint0_linear_19762_2058)"
        />
        <path
          d="M32.3041 66.7345C30.5821 66.5431 21.9634 64.4419 19.4293 58.5809C17.8645 54.9613 17.2863 51.1694 17.4096 47.267C17.4436 46.2016 17.1332 45.6912 16.1 45.3722C13.889 44.6916 11.8757 43.6198 10.3067 41.8589C10.5831 41.9185 10.8084 42.0631 11.0317 42.2077C14.5459 44.4939 18.3705 45.4594 22.5714 45.1723C28.3945 44.7724 32.8335 41.3889 38.0315 38.2245C37.4192 37.8502 36.9515 37.6269 36.5603 37.3079C36.133 36.957 35.7014 36.5678 35.4059 36.1106C31.1667 29.5583 25.0354 25.4134 17.9857 22.468C16.9185 22.0214 16.4019 21.4727 16.1914 20.3158C15.8066 18.1828 14.9966 16.1795 13.8103 14.2612C7.84909 17.9127 3.65455 22.8912 0.550627 28.8778C0.191337 30.8322 0 32.8483 0 34.9069C0 53.1834 14.8116 67.9998 33.0822 67.9998C36.9898 67.9998 40.5508 67.4193 44.031 66.1752C44.031 66.1752 37.3299 67.2917 32.3063 66.7345H32.3041ZM17.8837 29.0118C19.4271 29.7646 20.8941 30.4813 22.361 31.1958C22.2951 31.3532 22.2313 31.5106 22.1654 31.668C19.7567 32.5867 17.2034 31.685 17.8837 29.0118Z"
          fill="currentColor"
        />
        <defs>
          <linearGradient
            id="paint0_linear_19762_2058"
            x1="0"
            y1="33.5119"
            x2="67"
            y2="33.5119"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6948D3" stop-opacity="0.78" />
            <stop offset="1" stop-color="#FD5842" stop-opacity="0.78" />
          </linearGradient>
        </defs>
      </svg>
      <!--/ logo -->
      <div class="__logo my-auto text-3xl">Screel</div>
    </div>

    <div class="flex space-x-5 text-sm">
      <a href="#"> Privacy Policy</a>
      <a href="#">Report a bug</a>
      <a href="#">Backers</a>
      <div class="flex space-x-4">
        <!-- twitter icon -->
        <a href="#" target="_blank" rel="noopener noreferrer">
          <svg
            width="20"
            height="17"
            viewBox="0 0 20 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.29 16.0014C13.837 16.0014 17.965 9.84528 17.965 4.50628C17.965 4.33128 17.965 4.15731 17.953 3.98431C18.7544 3.41401 19.4477 2.70545 20 1.89153C19.2505 2.21918 18.4565 2.43356 17.644 2.52825C18.497 2.02724 19.1383 1.23287 19.448 0.29339C18.6407 0.764408 17.7596 1.09571 16.842 1.27337C16.0892 0.491063 15.0599 0.0345959 13.9747 0.00188605C12.8895 -0.0308238 11.8346 0.36302 11.036 1.09857C10.514 1.5792 10.1291 2.18989 9.92052 2.8681C9.71196 3.5463 9.68728 4.26755 9.849 4.95843C8.22359 4.88084 6.63217 4.46526 5.17612 3.7387C3.72008 3.01214 2.43133 1.99031 1.392 0.738214C0.868251 1.62758 0.708074 2.68479 0.944877 3.68939C1.18168 4.69398 1.79718 5.56849 2.663 6.1303C2.01078 6.11179 1.37228 5.93883 0.8 5.62542V5.6762C0.801 7.5992 2.178 9.25516 4.092 9.63616C3.48779 9.79868 2.85463 9.82261 2.24 9.7055C2.777 11.3515 4.318 12.4782 6.073 12.5112C4.34672 13.8444 2.16567 14.4463 0 14.1865C1.88279 15.3739 4.06405 16.0022 6.29 15.9985"
              fill="currentColor"
            />
          </svg>
        </a>
        <!--/ twitter icon -->
        <!-- github icon -->
        <a
          href="https://github.com/FotieMConstant/screel"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_19357_3058)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 0C15.523 0 20 4.58993 20 10.2529C20 14.7819 17.138 18.624 13.167 19.981C12.66 20.082 12.48 19.7618 12.48 19.4888C12.48 19.1508 12.492 18.0468 12.492 16.6748C12.492 15.7188 12.172 15.0949 11.813 14.7769C14.04 14.5229 16.38 13.6558 16.38 9.71777C16.38 8.59777 15.992 7.68382 15.35 6.96582C15.454 6.70682 15.797 5.66395 15.252 4.25195C15.252 4.25195 14.414 3.97722 12.505 5.30322C11.6894 5.07588 10.8467 4.95961 10 4.95801C9.15392 4.95954 8.31194 5.0758 7.497 5.30322C5.586 3.97722 4.746 4.25195 4.746 4.25195C4.203 5.66395 4.546 6.70682 4.649 6.96582C4.01 7.68382 3.619 8.59777 3.619 9.71777C3.619 13.6458 5.954 14.5262 8.175 14.7852C7.889 15.0412 7.63 15.4928 7.54 16.1558C6.97 16.4178 5.522 16.8712 4.63 15.3042C4.63 15.3042 4.101 14.3191 3.097 14.2471C3.097 14.2471 2.122 14.2341 3.029 14.8701C3.029 14.8701 3.684 15.1851 4.139 16.3701C4.139 16.3701 4.726 18.2001 7.508 17.5801C7.513 18.4371 7.522 19.2448 7.522 19.4888C7.522 19.7598 7.338 20.0769 6.839 19.9819C2.865 18.6269 0 14.7829 0 10.2529C0 4.58993 4.478 0 10 0Z"
                fill="#8B949E"
              />
            </g>
            <defs>
              <clipPath id="clip0_19357_3058">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
        <!--/ github icon -->
        <!-- discord icon -->
        <a
          href="https://discord.gg/7mqC4qc7bt"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_19357_3054)">
              <path
                d="M7.9639 9.21729C7.35415 9.21729 6.87378 9.75166 6.87378 10.4042C6.87378 11.0544 7.3654 11.591 7.9639 11.591C8.57253 11.591 9.0529 11.0544 9.0529 10.4042C9.06528 9.75053 8.57253 9.21729 7.9639 9.21729ZM11.8654 9.21729C11.2556 9.21729 10.7753 9.75166 10.7753 10.4042C10.7753 11.0544 11.2669 11.591 11.8654 11.591C12.474 11.591 12.9544 11.0544 12.9544 10.4042C12.9533 9.75053 12.474 9.21729 11.8654 9.21729Z"
                fill="#8B949E"
              />
              <path
                d="M17.0596 0.25H2.73725C2.44887 0.250738 2.16346 0.30827 1.89731 0.419311C1.63116 0.530352 1.38949 0.692728 1.1861 0.897168C0.9827 1.10161 0.821564 1.34411 0.711888 1.61082C0.602212 1.87754 0.546143 2.16324 0.546882 2.45162V16.9011C0.546882 18.1195 1.53013 19.1027 2.73725 19.1027H14.8569L14.2887 17.1239L15.6579 18.3962L16.9505 19.5932L19.25 21.625V2.45162C19.2507 2.16324 19.1947 1.87754 19.085 1.61082C18.9753 1.34411 18.8142 1.10161 18.6108 0.897168C18.4074 0.692728 18.1657 0.530352 17.8996 0.419311C17.6334 0.30827 17.348 0.250738 17.0596 0.25V0.25ZM12.9331 14.2079C12.9331 14.2079 12.5484 13.7489 12.2289 13.3405C13.6284 12.9445 14.1627 12.0692 14.1627 12.0692C13.724 12.3572 13.3077 12.562 12.9331 12.7015C11.5693 13.2723 10.0673 13.428 8.61537 13.1492C8.07886 13.0438 7.55316 12.8895 7.04487 12.688C6.7768 12.5862 6.51628 12.4655 6.26525 12.3269C6.23262 12.3032 6.20112 12.2942 6.16962 12.2729C6.15277 12.2648 6.13782 12.2533 6.12575 12.2391C5.93337 12.1334 5.8265 12.0591 5.8265 12.0591C5.8265 12.0591 6.3395 12.9141 7.69737 13.3202C7.37675 13.7252 6.98075 14.2079 6.98075 14.2079C4.61938 14.1325 3.72275 12.5834 3.72275 12.5834C3.72275 9.14199 5.26175 6.35312 5.26175 6.35312C6.80075 5.19774 8.26437 5.23037 8.26437 5.23037L8.37125 5.35862C6.4475 5.91549 5.55988 6.75924 5.55988 6.75924C5.55988 6.75924 5.79613 6.63099 6.191 6.44987C7.334 5.94812 8.24187 5.80862 8.6165 5.77599C8.68062 5.76587 8.73462 5.75462 8.79875 5.75462C10.6519 5.50489 12.5362 5.85706 14.174 6.75924C14.174 6.75924 13.3291 5.95824 11.5122 5.40249L11.6619 5.23149C11.6619 5.23149 13.1266 5.19887 14.6645 6.35424C14.6645 6.35424 16.2035 9.14311 16.2035 12.5845C16.2035 12.5834 15.2956 14.1325 12.9331 14.2079V14.2079Z"
                fill="#8B949E"
              />
            </g>
            <defs>
              <clipPath id="clip0_19357_3054">
                <rect width="21" height="21" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>

        <!--/ discord icon -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
